/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvaluationFeedbackCategory } from './evaluationFeedbackCategory';

/**
 * Structured not-helpful category when the student chose a preset reason
 */
export type StudentEvaluationFeedbackCategory = EvaluationFeedbackCategory | null;
